export { default } from './ModalImage';
